import React from 'react';

const Dropdown = ({ isRequired, value, options, onChange }) => {
  return (
    <select required={isRequired} value={value} onChange={onChange}>
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
